import {useTranslation} from "react-i18next";

export const offerReservationStatus = () => {
  const {t} = useTranslation();

  return [
    {id: "NOT_BOOKED", name: t('offer.status.new')},
    {id: "CANCELLED_BEFORE_BOOKED", name: t('offer.status.cancelled_before_booked')},
    {id: "NEW", name: t('offer.status.pending')},
    {id: "IN_PROGRESS", name: t('offer.status.in_progress')},
    {id: "CONFIRMED", name: t('offer.status.confirmed')},
    {id: "CANCELLED", name: t('offer.status.cancelled')},
    {id: "CANCELLED_UNSEEN", name: t('offer.status.cancelled')},
    {id: "REJECTED", name: t('offer.status.rejected')},
  ];
}
